import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const useUsdModeStore = create()(persist((set) => ({
    isUsdMode: false,
    usdAmount: '',
    toggleMode: () => set((state) => ({ isUsdMode: !state.isUsdMode })),
    setUsdAmount: (amount) => set({ usdAmount: amount }),
    reset: () => set({ isUsdMode: false, usdAmount: '' }),
}), {
    name: 'usd-mode',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({ isUsdMode: state.isUsdMode }),
}));
